"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sqr6020DocumentDefinition = void 0;
const luxon_1 = require("luxon");
const ramda_1 = require("ramda");
const __1 = require("../..");
const getPromotionRequirementsForMember = __1.memoize((loopmember) => loopmember.member.type === 'CAPProspectiveMember'
    ? undefined
    : __1.CadetHFZRequirementsMap.find(hfzentry => hfzentry.Gender === loopmember.member.gender &&
        hfzentry.Age ===
            (Math.floor((new Date().getTime() -
                loopmember.member.dateOfBirth) /
                (1000 * 60 * 60 * 24 * 365)) > 18
                ? 18
                : Math.floor((new Date().getTime() -
                    loopmember.member.dateOfBirth) /
                    (1000 * 60 * 60 * 24 * 365)))), requirements => requirements.member.id);
const sqr6020DocumentDefinition = (nhqmembers, prospectiveMembers, registry) => {
    const myTitleFontSize = 10;
    const mySmallFontSize = 7;
    const sortByMemberName = (a, b) => {
        const aMember = 'member' in a ? a.member : a;
        const bMember = 'member' in b ? b.member : b;
        return `${aMember.nameLast}, ${aMember.nameFirst}`.localeCompare(`${bMember.nameLast}, ${bMember.nameFirst}`);
    };
    function sortNHQName(a, b) {
        const aName = a.member.nameLast + ', ' + a.member.nameFirst;
        const bName = b.member.nameLast + ', ' + b.member.nameFirst;
        return aName.localeCompare(bName);
    }
    const getHFZExpire = (reqs) => ramda_1.pipe(__1.get('HFZRecord'), __1.Maybe.filter(({ IsPassed }) => IsPassed || reqs.CurrentCadetAchv.CadetAchvID < 4), __1.Maybe.map(({ DateTaken }) => DateTaken.substr(0, 10)), __1.Maybe.map(s => +new Date(s) + 182 * 24 * 60 * 60 * 1000), __1.Maybe.map(s => new Date(s).toLocaleDateString('en-US')), __1.Maybe.orSome(''))(reqs);
    const daysInMonth = (month, year) => new Date(year, month, 0).getDate();
    function getNextMonth() {
        const today = new Date();
        const thisMonth = today.getMonth();
        const nextMonth = ((thisMonth + 1) % 12) + 1;
        return new Date(nextMonth.toString() +
            '/' +
            daysInMonth(today.getFullYear(), nextMonth).toString() +
            '/' +
            today.getFullYear().toString());
    }
    const phase1Cadets = nhqmembers.filter(memberItem => memberItem.requirements.CurrentCadetAchv.CadetAchvID < 4);
    const phase234CadetsThatNeedPT = nhqmembers.filter(memberItem => memberItem.requirements.CurrentCadetAchv.CadetAchvID >= 4 &&
        new Date(getHFZExpire(memberItem.requirements)).getTime() < getNextMonth().getTime());
    const phase234CadetsThatDontNeedPT = nhqmembers.filter(memberItem => memberItem.requirements.CurrentCadetAchv.CadetAchvID >= 4 &&
        new Date(getHFZExpire(memberItem.requirements)).getTime() > getNextMonth().getTime());
    const tableHeaders1 = [
        {
            text: 'CAPID',
            fontSize: mySmallFontSize,
            bold: true,
            alignment: 'left',
        },
        {
            text: 'Full Name',
            fontSize: mySmallFontSize,
            bold: true,
            alignment: 'left',
        },
        {
            text: 'HFZ Expire Date',
            fontSize: mySmallFontSize,
            bold: true,
            alignment: 'left',
        },
        {
            text: 'Pacer Req.',
            fontSize: mySmallFontSize,
            bold: true,
            alignment: 'left',
        },
        {
            text: 'Pacer Score',
            fontSize: mySmallFontSize,
            bold: true,
            alignment: 'left',
        },
        {
            text: 'Mile Run Req.',
            fontSize: mySmallFontSize,
            bold: true,
            alignment: 'left',
        },
        {
            text: 'Mile Run Score',
            fontSize: mySmallFontSize,
            bold: true,
            alignment: 'left',
        },
        {
            text: 'Curl Up Req.',
            fontSize: mySmallFontSize,
            bold: true,
            alignment: 'left',
        },
        {
            text: 'Curl Up Score',
            fontSize: mySmallFontSize,
            bold: true,
            alignment: 'left',
        },
        {
            text: 'Push Up Req.',
            fontSize: mySmallFontSize,
            bold: true,
            alignment: 'left',
        },
        {
            text: 'Push Up Score',
            fontSize: mySmallFontSize,
            bold: true,
            alignment: 'left',
        },
        {
            text: 'Sit Reach Req.',
            fontSize: mySmallFontSize,
            bold: true,
            alignment: 'left',
        },
        {
            text: 'Sit Reach Score',
            fontSize: mySmallFontSize,
            bold: true,
            alignment: 'left',
        },
    ];
    const copyObject = (obj) => ({ ...obj });
    const tableHeaders2 = tableHeaders1.map(copyObject);
    const tableHeaders3 = tableHeaders1.map(copyObject);
    const mapFunc = (loopmember) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        return [
            {
                text: loopmember.member.id,
                fontSize: mySmallFontSize,
                bold: false,
                alignment: 'left',
            },
            {
                text: `${loopmember.member.memberRank} ${loopmember.member.nameLast}, ${loopmember.member.nameFirst}`,
                fontSize: mySmallFontSize,
                bold: false,
                decoration: new Date(loopmember.member.expirationDate + 60 * 60 * 24).getTime() -
                    new Date().getTime() <=
                    0
                    ? 'lineThrough'
                    : '',
                alignment: 'left',
            },
            {
                text: getHFZExpire(loopmember.requirements),
                fontSize: mySmallFontSize,
                bold: false,
                alignment: 'right',
            },
            {
                text: (_b = (_a = getPromotionRequirementsForMember(loopmember)) === null || _a === void 0 ? void 0 : _a.Pacer) !== null && _b !== void 0 ? _b : '',
                fontSize: mySmallFontSize,
                bold: false,
                alignment: 'right',
            },
            {
                text: '',
                fontSize: mySmallFontSize,
            },
            {
                text: (_d = (_c = getPromotionRequirementsForMember(loopmember)) === null || _c === void 0 ? void 0 : _c.MileRun) !== null && _d !== void 0 ? _d : '',
                fontSize: mySmallFontSize,
                bold: false,
                alignment: 'right',
            },
            {
                text: '',
                fontSize: mySmallFontSize,
            },
            {
                text: (_f = (_e = getPromotionRequirementsForMember(loopmember)) === null || _e === void 0 ? void 0 : _e.CurlUps) !== null && _f !== void 0 ? _f : '',
                fontSize: mySmallFontSize,
                bold: false,
                alignment: 'right',
            },
            {
                text: '',
                fontSize: mySmallFontSize,
            },
            {
                text: (_h = (_g = getPromotionRequirementsForMember(loopmember)) === null || _g === void 0 ? void 0 : _g.PushUps) !== null && _h !== void 0 ? _h : '',
                fontSize: mySmallFontSize,
                bold: false,
                alignment: 'right',
            },
            {
                text: '',
                fontSize: mySmallFontSize,
            },
            {
                text: (_k = (_j = getPromotionRequirementsForMember(loopmember)) === null || _j === void 0 ? void 0 : _j.SitReach) !== null && _k !== void 0 ? _k : '',
                fontSize: mySmallFontSize,
                bold: false,
                alignment: 'right',
            },
            {
                text: '',
                fontSize: mySmallFontSize,
            },
        ];
    };
    const phase1CadetsDoc = [
        ...phase1Cadets,
        ...prospectiveMembers.filter(mem => mem.memberRank === 'CADET'),
    ]
        .sort(sortByMemberName)
        .map((mem) => ({
        requirements: 'requirements' in mem ? mem.requirements : null,
        member: 'member' in mem ? mem.member : mem,
    }))
        .map((loopmember) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        return [
            {
                text: loopmember.member.id,
                fontSize: mySmallFontSize,
                bold: false,
                alignment: 'left',
            },
            {
                text: `${loopmember.member.memberRank} ${loopmember.member.nameLast}, ${loopmember.member.nameFirst}`,
                fontSize: mySmallFontSize,
                bold: false,
                decoration: loopmember.member.type === 'CAPNHQMember' &&
                    new Date(loopmember.member.expirationDate + 60 * 60 * 24).getTime() -
                        new Date().getTime() <=
                        0
                    ? 'lineThrough'
                    : '',
                alignment: 'left',
            },
            {
                text: loopmember.requirements !== null ? getHFZExpire(loopmember.requirements) : '',
                fontSize: mySmallFontSize,
                bold: false,
                alignment: 'right',
            },
            {
                text: (_b = (_a = getPromotionRequirementsForMember(loopmember)) === null || _a === void 0 ? void 0 : _a.Pacer) !== null && _b !== void 0 ? _b : '',
                fontSize: mySmallFontSize,
                bold: false,
                alignment: 'right',
            },
            {
                text: '',
                fontSize: mySmallFontSize,
            },
            {
                text: (_d = (_c = getPromotionRequirementsForMember(loopmember)) === null || _c === void 0 ? void 0 : _c.MileRun) !== null && _d !== void 0 ? _d : '',
                fontSize: mySmallFontSize,
                bold: false,
                alignment: 'right',
            },
            {
                text: '',
                fontSize: mySmallFontSize,
            },
            {
                text: (_f = (_e = getPromotionRequirementsForMember(loopmember)) === null || _e === void 0 ? void 0 : _e.CurlUps) !== null && _f !== void 0 ? _f : '',
                fontSize: mySmallFontSize,
                bold: false,
                alignment: 'right',
            },
            {
                text: '',
                fontSize: mySmallFontSize,
            },
            {
                text: (_h = (_g = getPromotionRequirementsForMember(loopmember)) === null || _g === void 0 ? void 0 : _g.PushUps) !== null && _h !== void 0 ? _h : '',
                fontSize: mySmallFontSize,
                bold: false,
                alignment: 'right',
            },
            {
                text: '',
                fontSize: mySmallFontSize,
            },
            {
                text: (_k = (_j = getPromotionRequirementsForMember(loopmember)) === null || _j === void 0 ? void 0 : _j.SitReach) !== null && _k !== void 0 ? _k : '',
                fontSize: mySmallFontSize,
                bold: false,
                alignment: 'right',
            },
            {
                text: '',
                fontSize: mySmallFontSize,
            },
        ];
    });
    const phase1CadetsDocTable = phase1CadetsDoc.length === 0
        ? {
            text: 'There are no Phase 1 Cadets in this unit.',
            fontSize: myTitleFontSize - 2,
            bold: true,
            alignment: 'left',
        }
        : {
            table: {
                headerRows: 1,
                widths: [
                    34,
                    95,
                    36,
                    29,
                    29,
                    29,
                    29,
                    29,
                    29,
                    29,
                    29,
                    29,
                    29,
                ],
                body: [tableHeaders1, ...phase1CadetsDoc],
            },
            layout: {
                fillColor: rowIndex => (rowIndex % 2 === 0 ? '#CCCCCC' : null),
            },
        };
    const phase234CadetsExpiringDoc = phase234CadetsThatNeedPT.sort(sortNHQName).map(mapFunc);
    const phase234CadetsExpiringDocTable = phase234CadetsExpiringDoc.length === 0
        ? {
            text: 'There are no Phase 2-4 Cadets with expiring PT',
            fontSize: myTitleFontSize - 2,
            bold: true,
            alignment: 'left',
        }
        : {
            table: {
                headerRows: 1,
                widths: [
                    24,
                    95,
                    36,
                    29,
                    29,
                    29,
                    29,
                    29,
                    29,
                    29,
                    29,
                    29,
                    29,
                ],
                body: [tableHeaders2, ...phase234CadetsExpiringDoc],
            },
            layout: {
                fillColor: rowIndex => (rowIndex % 2 === 0 ? '#CCCCCC' : null),
            },
        };
    const phase234CadetsNotExpiringDoc = phase234CadetsThatDontNeedPT
        .sort(sortNHQName)
        .map(mapFunc);
    const phase234CadetsNotExpiringDocTable = phase234CadetsNotExpiringDoc.length === 0
        ? {
            text: 'There are no Phase 2-4 Cadets without expiring PT',
            fontSize: myTitleFontSize - 2,
            bold: true,
            alignment: 'left',
        }
        : {
            table: {
                headerRows: 1,
                widths: [
                    24,
                    95,
                    36,
                    29,
                    29,
                    29,
                    29,
                    29,
                    29,
                    29,
                    29,
                    29,
                    29,
                ],
                body: [tableHeaders3, ...phase234CadetsNotExpiringDoc],
            },
            layout: {
                fillColor: rowIndex => (rowIndex % 2 === 0 ? '#CCCCCC' : null),
            },
        };
    const nowDate = luxon_1.DateTime.utc();
    const docDefinition = {
        pageSize: 'LETTER',
        pageOrientation: 'landscape',
        pageMargins: [25, 40, 64, 40],
        header: {
            text: registry.Website.Name +
                ' Cadet HFZ Status Report: ' +
                nhqmembers.length.toString() +
                ' members',
            alignment: 'left',
            fontSize: myTitleFontSize,
            bold: true,
            margin: [30, 20, 40, 35],
        },
        footer: (currentPage, pageCount) => {
            var _a;
            return [
                {
                    layout: 'noBorders',
                    table: {
                        widths: [792 - 72],
                        headerRows: 0,
                        body: [
                            [
                                {
                                    layout: 'noBorders',
                                    table: {
                                        widths: ['*', 306, '*'],
                                        headerRows: 0,
                                        body: [
                                            [
                                                {
                                                    text: 'Squadron Report 60-20 Oct 2021',
                                                    bold: true,
                                                    fontSize: mySmallFontSize,
                                                },
                                                {
                                                    text: `Generated by Event Manager on ${(_a = nowDate.toLocaleString({
                                                        year: 'numeric',
                                                        month: '2-digit',
                                                        day: '2-digit',
                                                    })) !== null && _a !== void 0 ? _a : ''}`,
                                                    bold: false,
                                                    fontSize: mySmallFontSize,
                                                    alignment: 'center',
                                                },
                                                {
                                                    text: `Page ${currentPage} of ${pageCount}`,
                                                    bold: false,
                                                    fontSize: mySmallFontSize,
                                                    alignment: 'right',
                                                },
                                            ],
                                        ],
                                    },
                                },
                            ],
                        ],
                    },
                    margin: [30, 0, 0, 60],
                },
            ];
        },
        content: [
            {
                text: 'Phase 1 Cadets',
                alignment: 'left',
                fontSize: myTitleFontSize - 1,
                bold: true,
            },
            phase1CadetsDocTable,
            {
                text: ' ',
                alignment: 'left',
                fontSize: mySmallFontSize,
                bold: true,
            },
            {
                text: 'Phase 2-4 Cadets whose HFZ credit expires before ' +
                    getNextMonth().toLocaleDateString(),
                alignment: 'left',
                fontSize: myTitleFontSize - 1,
                bold: true,
            },
            phase234CadetsExpiringDocTable,
            {
                text: ' ',
                alignment: 'left',
                fontSize: mySmallFontSize,
                bold: true,
            },
            {
                text: 'Phase 2-4 Cadets whose HFZ credit is not expiring',
                alignment: 'left',
                fontSize: myTitleFontSize - 1,
                bold: true,
            },
            phase234CadetsNotExpiringDocTable,
            {
                text: ' ',
                alignment: 'left',
                fontSize: mySmallFontSize,
                bold: true,
                pageBreak: 'before',
            },
            {
                text: 'Healthy Fitness Zone Standards',
                alignment: 'left',
                fontSize: myTitleFontSize,
                bold: true,
            },
            {
                text: 'Males',
                alignment: 'left',
                fontSize: myTitleFontSize - 2,
                bold: true,
            },
            {
                table: {
                    headerRows: 1,
                    widths: [
                        32,
                        32,
                        32,
                        32,
                        32,
                        36,
                        36,
                    ],
                    body: [
                        [
                            {
                                text: 'Age',
                                fontSize: mySmallFontSize,
                                bold: true,
                                alignment: 'center',
                            },
                            {
                                text: 'Pacer',
                                fontSize: mySmallFontSize,
                                bold: true,
                                alignment: 'center',
                            },
                            {
                                text: 'Mile Run',
                                fontSize: mySmallFontSize,
                                bold: true,
                                alignment: 'center',
                            },
                            {
                                text: 'Curl Ups',
                                fontSize: mySmallFontSize,
                                bold: true,
                                alignment: 'center',
                            },
                            {
                                text: 'Push Ups',
                                fontSize: mySmallFontSize,
                                bold: true,
                                alignment: 'center',
                            },
                            {
                                text: 'Sit Reach',
                                fontSize: mySmallFontSize,
                                bold: true,
                                alignment: 'center',
                            },
                        ],
                        ...__1.CadetHFZRequirementsMap.filter(({ Gender }) => Gender === 'MALE').map(requirements => [
                            {
                                text: `${requirements.Age}`,
                                fontSize: mySmallFontSize,
                                bold: false,
                                alignment: 'center',
                            },
                            {
                                text: `${requirements.Pacer}`,
                                fontSize: mySmallFontSize,
                                bold: false,
                                alignment: 'center',
                            },
                            {
                                text: `${requirements.MileRun}`,
                                fontSize: mySmallFontSize,
                                bold: false,
                                alignment: 'center',
                            },
                            {
                                text: `${requirements.CurlUps}`,
                                fontSize: mySmallFontSize,
                                bold: false,
                                alignment: 'center',
                            },
                            {
                                text: `${requirements.PushUps}`,
                                fontSize: mySmallFontSize,
                                bold: false,
                                alignment: 'center',
                            },
                            {
                                text: `${requirements.SitReach}`,
                                fontSize: mySmallFontSize,
                                bold: false,
                                alignment: 'center',
                            },
                        ]),
                    ],
                },
                layout: {
                    fillColor: rowIndex => (rowIndex % 2 === 0 ? '#CCCCCC' : null),
                },
            },
            {
                text: ' ',
                alignment: 'left',
                fontSize: mySmallFontSize,
                bold: true,
            },
            {
                text: 'Females',
                alignment: 'left',
                fontSize: myTitleFontSize - 2,
                bold: true,
            },
            {
                table: {
                    headerRows: 1,
                    widths: [
                        32,
                        32,
                        32,
                        32,
                        32,
                        36,
                        36,
                    ],
                    body: [
                        [
                            {
                                text: 'Age',
                                fontSize: mySmallFontSize,
                                bold: true,
                                alignment: 'center',
                            },
                            {
                                text: 'Pacer',
                                fontSize: mySmallFontSize,
                                bold: true,
                                alignment: 'center',
                            },
                            {
                                text: 'Mile Run',
                                fontSize: mySmallFontSize,
                                bold: true,
                                alignment: 'center',
                            },
                            {
                                text: 'Curl Ups',
                                fontSize: mySmallFontSize,
                                bold: true,
                                alignment: 'center',
                            },
                            {
                                text: 'Push Ups',
                                fontSize: mySmallFontSize,
                                bold: true,
                                alignment: 'center',
                            },
                            {
                                text: 'Sit Reach',
                                fontSize: mySmallFontSize,
                                bold: true,
                                alignment: 'center',
                            },
                        ],
                        ...__1.CadetHFZRequirementsMap.filter(({ Gender }) => Gender === 'FEMALE').map(requirements => [
                            {
                                text: `${requirements.Age}`,
                                fontSize: mySmallFontSize,
                                bold: false,
                                alignment: 'center',
                            },
                            {
                                text: `${requirements.Pacer}`,
                                fontSize: mySmallFontSize,
                                bold: false,
                                alignment: 'center',
                            },
                            {
                                text: `${requirements.MileRun}`,
                                fontSize: mySmallFontSize,
                                bold: false,
                                alignment: 'center',
                            },
                            {
                                text: `${requirements.CurlUps}`,
                                fontSize: mySmallFontSize,
                                bold: false,
                                alignment: 'center',
                            },
                            {
                                text: `${requirements.PushUps}`,
                                fontSize: mySmallFontSize,
                                bold: false,
                                alignment: 'center',
                            },
                            {
                                text: `${requirements.SitReach}`,
                                fontSize: mySmallFontSize,
                                bold: false,
                                alignment: 'center',
                            },
                        ]),
                    ],
                },
                layout: {
                    fillColor: rowIndex => (rowIndex % 2 === 0 ? '#CCCCCC' : null),
                },
            },
        ],
        defaultStyle: {
            font: 'FreeSans',
        },
    };
    return docDefinition;
};
exports.sqr6020DocumentDefinition = sqr6020DocumentDefinition;
//# sourceMappingURL=sqr6020.js.map